import { useState } from "react";
import useDataFetch, {
  DataFetchOptionsType,
} from "../../../../hooks/useDataFetch";
import { getTopicAPIresponse } from "../../services";
import RenderLoading from "./partials/renderLoading";
import RenderError from "./partials/renderError";
import RenderGrid from "./partials/renderGrid";

const StepTwo = () => {
  const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({});
  // const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({
  //   error: { msg: "API Failed" },
  // });
  const { loading, data, error } = useDataFetch(
    getTopicAPIresponse,
    fetchOptions
  );

  if (loading) {
    return <RenderLoading />;
  }

  if (error) {
    return (
      <RenderError
        error={error}
        onRetry={() => {
          setFetchOptions({
            loading: true,
          });
          setTimeout(() => {
            setFetchOptions({ requestId: new Date().getTime().toString() });
          }, 1000);
        }}
      />
    );
  }

  if (data) {
    return <RenderGrid topics={data} />;
  }

  return null;
};

export default StepTwo;
